export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 tracking-widest uppercase mb-2">Contact</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            有任何问题或建议，欢迎通过以下方式联系被窝网电影团队
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: 'ri-mail-line', label: '联系邮箱', value: 'hello@beiwowang.com' },
              { icon: 'ri-wechat-line', label: '官方微信', value: '被窝网电影' },
              { icon: 'ri-weibo-line', label: '官方微博', value: '@被窝网电影' },
            ].map((c) => (
              <div key={c.label} className="bg-background-50 rounded-xl p-5 text-center border border-background-200/60">
                <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-50 flex items-center justify-center">
                  <i className={`${c.icon} text-accent-500 text-lg`}></i>
                </div>
                <p className="text-xs text-foreground-400 mb-1 whitespace-nowrap">{c.label}</p>
                <p className="text-sm font-medium text-foreground-700 whitespace-nowrap">{c.value}</p>
              </div>
            ))}
          </div>

          <p className="text-center text-xs text-foreground-400 mt-8">
            工作时间：周一至周五 9:00 - 18:00，我们会在 24 小时内回复您的留言
          </p>
        </div>
      </div>
    </section>
  );
}